import parser from './parser';

const name = 'checkbox';

export default {parser, name};
